// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._zulp1nty{gap:0 0}._16jlkb7n{flex-grow:1}\n._1bsb1osq{width:100%}\n._1e0c11p5{display:grid}\n._1e0c1txw{display:flex}\n._1lmcpu6d{grid-template-areas:\"axis-left plot\" \". axis-bottom\"}\n._1tkeidpf{min-height:0}\n._1ul9idpf{min-width:0}\n._2z051qft{grid-template-rows:auto min-content}\n._4t3i1osq{height:100%}\n._kqswh2mm{position:relative}\n._yv0ey09t{grid-template-columns:min-content auto}", ""]);
// Exports
module.exports = exports;
